module.exports = __webpack_public_path__ + "static/media/blue-pg1.6eeab7ff.png";